import React, { useState } from 'react';
import DatePicker from 'react-date-picker';
import { formatDateReverse } from '../../../helpers/dateFormatter';
import { APARTMENT_CERTIFICATE } from '../../../constants/ApartmentConstants';
import ApartmentService from '../../../services/ApartmentService';

function PrintCertificateComponent(props) {
    const [printError, setPrintError] = useState(null);
    const [certficate_startDate, setCertficateStartDate] = useState(null);
    const [certificate_printedDate, setCertificatePrintedDate] = useState(null);

    const clickGenerateApartmentCertificate = (e) => {
        e.preventDefault();
        if (certficate_startDate === null || certificate_printedDate === null) {
            setPrintError('Venligst udfyld alle felterne');
            return;
        }

        generateApartmentCertificate(props.apartment.id, formatDateReverse(certficate_startDate), formatDateReverse(certificate_printedDate));

        ApartmentService.updateApartment({...props.apartment, andelsbevisDate: new Date(Date.now()).toISOString()})
        .catch(function (err) {
            alert("Der opstod en fejl");
            console.log("Error saving", err);
        });

        props.printCertificateClick();
    };

    const generateApartmentCertificate = (apartmentId, startDate, printedDate) => {
        window.open(APARTMENT_CERTIFICATE + apartmentId + "/" + startDate.replace(/\//g, '-') + "/" + printedDate.replace(/\//g, '-'), '_blank' // <- This is what makes it open in a new window.
        );
    };

    return <React.Fragment>
        {props.printCertificate &&
            <form className="apartmentForm " id="apartmentForm">
                <div className='col-md-12 slightMarginTopApartments'>
                    <div className="col-md-3 panelRowPadding">
                        {printError && <div className="printError">{printError}</div>}
                    </div>
                </div>
                <div className='col-md-12'>

                    <div className="col-md-3 panelRowPadding ">
                        <div>
                            <label>Indtrædelsesdato</label>
                        </div>
                        <DatePicker dateFormat="dd/MM/yyyy" value={certficate_startDate} onChange={date => { setCertficateStartDate(date); }} className="form-control" />

                    </div>
                    <div className="col-md-3 panelRowPadding ">
                        <div>
                            <label>Udstedelsesdato</label>
                        </div>
                        <DatePicker dateFormat="dd/MM/yyyy" value={certificate_printedDate} onChange={date => { setCertificatePrintedDate(date); }} className="form-control" />

                    </div>
                </div>
                <div className='col-md-12'>
                    <div className="col-md-offset-6 col-md-3 panelRowPadding">
                        <button className="btn btn-primary" onClick={props.printCertificateClick}>Afbryd</button>
                    </div>
                    <div className="col-md-3 panelRowPadding">
                        <button className="btn btn-primary" onClick={clickGenerateApartmentCertificate}>Print bevis</button>
                    </div>
                </div>
            </form>}
    </React.Fragment>;
}
export default PrintCertificateComponent;